exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pop-cover[data-v-7c9011b0]{position:relative}.delete-popover[data-v-7c9011b0]{position:absolute;right:32px;padding:10px;border-radius:4px;min-width:180px;bottom:-30px}", ""]);

// exports
